var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8558 6.88859C19.1557 7.4441 16.889 5.22205 17.4557 3.55551M17.3182 3.6903L13.6555 7.28073C12.0632 8.84163 10.9336 10.7974 10.3874 12.9389L10.2104 13.6329C10.1553 13.8491 10.3551 14.045 10.5757 13.9909L11.2836 13.8174C13.4682 13.282 15.4633 12.1747 17.0556 10.6138L20.7183 7.02338C21.1692 6.58139 21.4225 5.98192 21.4225 5.35684C21.4225 4.05519 20.3461 3 19.0182 3C18.3806 3 17.7691 3.24831 17.3182 3.6903Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2414 3C11.1975 3 10.1536 3.11763 9.13046 3.35288C6.29716 4.00437 4.08489 6.17301 3.42028 8.95043C2.94031 10.9563 2.94031 13.0437 3.42028 15.0496C4.08489 17.827 6.29716 19.9956 9.13047 20.6471C11.1766 21.1176 13.3061 21.1176 15.3523 20.6471C18.1856 19.9956 20.3979 17.827 21.0625 15.0496C21.3025 14.0466 21.4225 13.0233 21.4225 12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/editIconWhite.5c74d6ffe36f613c4004f15005f4f7eb.svg";
export { ForwardRef as ReactComponent };